<template>
    <div class="rule-settings">
        <div class="item-wrapper">
            <span class="label">{{ $t('ticimax.automationRuleName') }}:</span>
            <div class="options">
                <a-input v-model="clone.name" />
            </div>
        </div>
        <div class="item-wrapper">
            <span class="label">{{ $t('ticimax.waitDayFromLastSend') }}:</span>
            <div class="options">
                <a-input-number v-model="clone.resendEnabledAfterDays" />
            </div>
        </div>
    </div>
</template>
<script>
import Vue from "vue";
import _ from "lodash";

export default Vue.extend({
    name: "RuleSettings",
    props: {
        value: {
            required: true,
        },
    },
    data() {
        return {
            clone: _.cloneDeep(this.value),
        };
    },
    watch: {
        clone: {
            handler: function (val) {
                this.$emit("input", val);
            },
            deep: true,
        },
        value: {
            handler: function (val) {
                if (!_.isEqual(val, this.clone)) {
                    this.clone = _.cloneDeep(val);
                }
            },
            deep: true,
        },
    },
});
</script>

<style scoped lang="scss">
.rule-settings {
    display: flex;
    flex-direction: column;
    gap: 10px;
    width: 100%;
    .item-wrapper {
        display: flex;
        gap: 10px;
        align-items: center;
        width: 100%;

        .label {
            font-weight: 700;
            width: 400px;
        }

        .options {
            display: flex;
            gap: 10px;
            flex-wrap: wrap;
            align-items: center;
            width: 100%;
        }
    }
}
</style>
